import(/* webpackMode: "eager" */ "/app/src/components/pages/tours/id/Client.tsx")